module.exports = __webpack_public_path__ + "static/img/main_banner2.b5636807.png";